import React, { useState } from "react";
import { Layout, Row, Col, Form, Input, Button } from "antd";
import {
  FullHeightRow,
  AuthLeftContainer,
  HaberForm,
  AuthTitleBlock,
} from "../styledElements";
import AuthRightContainer from "../../Components/AuthRightBox/authRightContainer";
import AlertContainer from "../../Components/AlertBoxes/alertBox";
import Logo from "../../Assets/Images/logo.svg";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../Services/forgotPasswordServices";
import { useNavigate } from "react-router-dom";
import alertRed from "../../Assets/Icons/alertRed.svg";
import alertGreen from "../../Assets/Icons/alertGreen.svg";

const validateMessages = {
  required: "This field is required!",
  types: {
    email: "Not a valid email format!",
  },
};

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const [warning, setWarning] = useState();
  const [message, setMessage] = useState();
  const onFinish = async (values) => {
    console.log("Useremail forgot password", values);

    if (values) {
      let email = values.useremail;
      try {
        const forgotPasswordResponse = await forgotPassword(values.useremail);
        if (!forgotPasswordResponse.data.error) {
          setAlert(true);
          setWarning(false);
          setMessage(forgotPasswordResponse.data.msg);

          setTimeout(() => {
            navigate(
              "/reset-verification",
              { state: { email } },
              { replace: true }
            );
          }, 2500);
        }
      } catch (error) {
        setAlert(true);
        setWarning(true);
        setMessage(error.response.data.msg);
        console.log(error);
      }
    }
  };
  return (
    <>
      <FullHeightRow>
        <Layout className="authLayout" style={{ backgroundColor: "#ffffff" }}>
          <Row span={24}>
            <Col span={12} className="colLayoutBlock">
              <AuthLeftContainer>
                <div className="flexBlock" style={{ justifyContent: "center" }}>
                  <div className="vCenterBlock">
                    <div className="hCenterBox">
                      <AuthTitleBlock>
                        <div className="logo">
                          <img src={Logo} alt="HaberERP" />
                        </div>
                        <h1>Reset Password</h1>
                        <p>
                          Enter your email address, we{"'"}ll send you
                          instructions to reset your password.
                        </p>
                      </AuthTitleBlock>
                      {alert ? (
                        <AlertContainer
                          color={warning ? "red" : "green"}
                          icon={warning ? alertRed : alertGreen}
                          msg={message}
                        />
                      ) : (
                        ""
                      )}
                      <HaberForm>
                        <Form
                          name="basic"
                          autoComplete="off"
                          className="haberLogin"
                          validateMessages={validateMessages}
                          onFinish={onFinish}
                        >
                          <Form.Item
                            name="useremail"
                            rules={[{ required: true, type: "email" }]}
                            className="mailIcon"
                          >
                            <Input placeholder="Enter your email address" />
                          </Form.Item>

                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="btnSubmit"
                              disabled={false}
                            >
                              Reset your password
                            </Button>
                          </Form.Item>
                        </Form>
                        <Link to="/login" className="backToLogin">
                          Go back to Login Page
                        </Link>
                        <div className="pageLinks">
                          <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                          <Link to="/terms-and-conditions">
                            Terms & Conditions
                          </Link>
                        </div>
                      </HaberForm>
                    </div>
                  </div>
                </div>
              </AuthLeftContainer>
            </Col>
            <Col span={12} className="colLayoutBlock">
              <AuthRightContainer />
            </Col>
          </Row>
        </Layout>
      </FullHeightRow>
    </>
  );
};

export default ResetPassword;
